import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/rootReducer';
import HSButton from '../../../common/Button';
import { RepaymentInfo } from '../../Investments/redux/types';
import RemarksModal from '../modal/Remarks';

const RepaymentCard: React.FC = () => {
    const repayments = useSelector((state: RootState) => state.investments.repayment?.repayments);

    const statusButton = (record: RepaymentInfo) => {
        switch (record.dealRepayment.status) {
            case 'PAID':
                return (
                    <HSButton
                        title="PAID"
                        style={{ backgroundColor: 'green', borderColor: 'green', minHeight: 'auto' }}
                    />
                );
            case 'LATE':
                return (
                    <HSButton
                        title="LATE"
                        style={{ backgroundColor: 'white', borderColor: 'red', color: '#000', minHeight: 'auto' }}
                    />
                );
            case 'UPCOMING':
                return (
                    <HSButton
                        title="UPCOMING"
                        style={{
                            backgroundColor: 'white',
                            borderColor: '#16365c',
                            color: '#16365c',
                            minHeight: 'auto',
                        }}
                    />
                );
            default:
                return null;
        }
    };

    return (
        <div>
            <p className="text-lg pb-4 SourceSansPro-SemiBold">Repayments</p>
            {repayments &&
                repayments.map((r, index) => (
                    <div
                        key={`repayment_mobile_${index}`}
                        className="rounded-md overflow-hidden shadow-lg bg-white h-full relative m-auto mb-4"
                    >
                        <div className="px-4 py-4">
                            <div className="flex justify-between items-center">
                                <div className="flex items-center">
                                    <label className="text-base pr-1">
                                        {r.dealRepayment.date && r.dealRepayment.date.date}
                                    </label>
                                    {r.dealRepayment.remarks && r.dealRepayment.remarks.length > 0 && (
                                        <RemarksModal list={r.dealRepayment.remarks || []} />
                                    )}
                                </div>
                                <div>{statusButton(r)}</div>
                            </div>
                            <div className="my-2" style={{ borderBottom: `1px solid lightgray` }} />
                            <div>
                                <div className="flex justify-between items-center">
                                    <p className="w-1/2">Expected Repayment</p>
                                    <p className="w-1/2 text-right">
                                        {r.investmentRepayment.expectedAmount &&
                                            `${r.investmentRepayment.expectedAmount.currency} ${
                                                r.investmentRepayment.expectedAmount.amountUpto2dp?.toLocaleString() ||
                                                '0'
                                            }`}
                                    </p>
                                </div>
                                <div className="flex justify-between items-center">
                                    <p className="w-1/2">Actual Repayment</p>
                                    <p className="w-1/2 text-right">
                                        {r.investmentRepayment.actualAmount &&
                                            `${r.investmentRepayment.actualAmount.currency} ${
                                                r.investmentRepayment.actualAmount.amountUpto2dp?.toLocaleString() ||
                                                '0'
                                            }`}
                                    </p>
                                </div>
                                <div className="flex justify-between items-center">
                                    <p className="w-1/2">Fee</p>
                                    <p className="w-1/2 text-right">
                                        {r.investmentRepayment.fee &&
                                            `${r.investmentRepayment.fee.currency} ${
                                                r.investmentRepayment.fee.amountUpto2dp?.toLocaleString() || '0'
                                            }`}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="px-4 py-3" style={{ backgroundColor: '#c49a6d' }}>
                            <div className="flex justify-between items-center">
                                <p className="w-1/2 text-white">Net Actual Repayment</p>
                                <p className="w-1/2 text-right text-white">
                                    {(r.investmentRepayment.actualAmount &&
                                        `${r.investmentRepayment.actualAmount.currency} ${(
                                            (r.investmentRepayment.actualAmount.amountUpto2dp || 0) -
                                            (r.investmentRepayment.fee.amountUpto2dp || 0)
                                        ).toLocaleString()} `) ||
                                        '-'}
                                </p>
                            </div>
                        </div>
                    </div>
                ))}
        </div>
    );
};

export default RepaymentCard;
